"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../core/button"));
var _editableField = _interopRequireDefault(require("../../core/editable-field"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DefaultRaceRow extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (value, name) => {
      this.props.onUpdate(this.props.race.id, name, value);
    });
    _defineProperty(this, "_onToggleExpired", () => {
      this.props.onUpdate(this.props.race.id, 'isExpired', !this.props.race.isExpired);
    });
  }
  render() {
    const race = this.props.race;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: race.id
    }, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "sm",
      onClick: this.props.toggleEligibilities,
      block: true
    }, this.props.showEligibilities ? 'Hide Eligibilities' : 'Show Eligibilities')), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, race.tierDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, race.eventDescription), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: !race.isExpired,
      name: "isMultiClass",
      checked: race.isMultiClass,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: !race.isExpired,
      value: race.raceName,
      onChange: this._onChange,
      type: "text",
      name: "raceName",
      maxLength: 25,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: !race.isExpired,
      value: race.simplySlalomName,
      onChange: this._onChange,
      type: "text",
      name: "simplySlalomName",
      maxLength: 25,
      required: false
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: !race.isExpired,
      value: race.siwiCode,
      onChange: this._onChange,
      type: "text",
      name: "siwiCode",
      maxLength: 10
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      type: "Checkbox",
      enabled: !race.isExpired,
      name: "showPaddlerRanking",
      checked: race.showPaddlerRanking,
      onChange: this._onChange
    })), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "link",
      size: "sm",
      onClick: this._onToggleExpired
    }, !race.isExpired ? 'Mark as Expired' : 'Restore')));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DefaultRaceRow, "partialQueries", {
  DefaultRace: {
    id: true,
    eventDescription: true,
    raceName: true,
    siwiCode: true,
    simplySlalomName: true,
    isMultiClass: true,
    showPaddlerRanking: true,
    isExpired: true,
    tierDescription: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(DefaultRaceRow, undefined, (client, props) => ({
  onUpdate(id, field, value) {
    return client.update('DefaultRace.set', {
      id,
      field,
      value
    });
  }
}));